<template>
  <div>
    <form class="sanitasForms" @submit.prevent>
      <button class="detail__button-back" @click="$emit('listClick')">
        <dotcom-icon
          name="chevron-right"
          art="light"
          rotation="180"
          class="detail__back-icon"
        />
        {{ $t('detailAndFilterBack') }}
      </button>
      <h5 class="detail__title">{{ detailItem.name }}</h5>
      <div class="detail__address-container">
        <div class="detail__address-part">
          <p class="detail__address-part-street">
            {{ detailItem.address.street }}
          </p>
          <p class="detail__address-part-ziptown">
            {{ detailItem.address.zipCode }}
            {{ detailItem.address.town }}
          </p>
        </div>
        <div class="detail__address-part">
          <p class="detail__address-part-phone">
            {{ detailItem.phoneNumber }}
          </p>
          <p class="detail__address-part-email">
            {{ detailItem.email }}
          </p>
        </div>
      </div>
      <hr class="detail__hr" />
      <div class="detail__button-container">
        <sanitas-button
          full-width-in-xs
          link
          :href="`tel:${detailItem.phoneNumber}`"
          secondary
          class="detail__button"
        >
          <dotcom-icon name="phone" art="light" flip="horizontal" />
          {{ $t('detailPhone') }}
        </sanitas-button>
        <sanitas-button
          full-width-in-xs
          link
          :href="`mailto:${detailItem.email}`"
          secondary
          class="detail__button"
        >
          <dotcom-icon name="envelope" art="light" />
          {{ $t('detailEmail') }}
        </sanitas-button>
        <sanitas-button
          full-width-in-xs
          link
          :href="`https://www.google.ch/maps/search/?api=1&query=${detailItem.address.latitude},${detailItem.address.longitude}`"
          target="_blank"
          secondary
          class="detail__button"
        >
          <dotcom-icon name="map-location-dot" art="light" />
          {{ $t('detailMap') }}
        </sanitas-button>
      </div>
      <hr class="detail__hr" />
      <div class="detail__filter-container">
        <div
          v-for="group in detailItem.filters"
          :key="group.groupKey"
          class="detail__filter-group"
        >
          <div class="detail__filter-group-title">
            {{ group.groupName }}
          </div>
          <div
            v-for="tag in group.tags"
            :key="tag.tagKey"
            class="detail__filter-group-row"
          >
            <div class="detail__filter-tag-name">
              <dotcom-icon
                v-if="tag.tagIcon"
                :name="tag.tagIcon"
                art="light"
                class="detail__filter-tag-icon"
              />
              {{ tag.tagName }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import SanitasButton from '@/components/sanitas-components/SanitasButton'
import DotcomIcon from '@/modules/icon/Icon'

export default {
  name: 'Detail',
  components: { DotcomIcon, SanitasButton },
  props: {
    detailItem: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },
}
</script>
<style lang="postcss" scoped>
.detail__button-back {
  background: none;
  border: none;
  padding: 0;
  color: var(--c-primary-neutral-1);
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 0.2px;
  margin-bottom: var(--spacing-6);
}

.detail__back-icon {
  margin-right: var(--spacing-1);
}

.detail__title {
  font-weight: bold;
  margin-bottom: var(--spacing-4);
  font-size: 14px;
}

.detail__address-container {
  display: flex;
  row-gap: var(--spacing-2);
  column-gap: var(--spacing-16);
  flex-direction: column;
}

.detail__address-part-street,
.detail__address-part-ziptown,
.detail__address-part-phone,
.detail__address-part-email {
  font-size: 14px;
  line-height: 20px;
}

.detail__address-part-street,
.detail__address-part-phone {
  margin-bottom: var(--spacing-1);
}

.detail__hr {
  border: 0;
  height: 1px;
  background: var(--c-secondary-neutral-3);
  margin: var(--spacing-4) calc(-1 * var(--spacing-8));
}

.detail__button-container {
  display: flex;
  gap: var(--spacing-4);
  flex-wrap: wrap;
}

.detail__button {
  display: flex;
  column-gap: var(--spacing-2);

  /* Needed to be specific enough */

  &.sanitas-button {
    margin-top: 0;
  }
}

.detail__filter-container {
  display: flex;
  gap: var(--spacing-2) var(--spacing-16);
  flex-wrap: wrap;
}

.detail__filter-group-title {
  font-size: 14px;
  font-weight: bold;
  margin: var(--spacing-2) 0;
}

.detail__filter-group-row {
  display: flex;
}

.detail__filter-tag-name {
  font-size: 14px;
  margin-bottom: var(--spacing-2);
  line-height: 20px;
}

.detail__filter-tag-icon {
  width: 24px;
}

@media (--sm) {
  .detail__address-container {
    flex-direction: row;
  }

  .detail__address-part-street,
  .detail__address-part-ziptown,
  .detail__address-part-phone,
  .detail__address-part-email,
  .detail__title {
    font-size: 16px;
  }

  .detail__button-container {
    gap: var(--spacing-2) var(--spacing-4);
  }
}
</style>
